import React, { useState } from 'react';
import { Box, Paper, Typography, Divider } from '@mui/material';
import AccountSelector from '../components/common/AccountSelector';
import CostCenterSelector from '../components/common/CostCenterSelector';
import EntryTypeSelector from '../components/common/EntryTypeSelector';
import FiscalYearSelector from '../components/common/FiscalYearSelector';
import { EntryTypeDto } from '../types/entryTypes.types';
import { useLanguage } from '../contexts/LanguageContext';

const SelectorsTestPage: React.FC = () => {
  const { language } = useLanguage();
  const isRTL = language === 'ar';

  const [accountId, setAccountId] = useState<number | null>(null);
  const [costCenterId, setCostCenterId] = useState<number | null>(null);
  const [entryTypeId, setEntryTypeId] = useState<number | null>(null);
  const [fiscalYearId, setFiscalYearId] = useState<number | null>(null);

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3, maxWidth: 800, mx: 'auto' }}>
        <Typography variant="h5" gutterBottom>
          {isRTL ? '🧪 اختبار المكونات الأربعة' : '🧪 Four Selectors Test'}
        </Typography>

        <Box sx={{ mt: 3, display: 'flex', flexDirection: 'column', gap: 3 }}>
          <Box>
            <Typography variant="subtitle2" gutterBottom>
              {isRTL ? '1️⃣ نوع القيد' : '1️⃣ Entry Type'}
            </Typography>
            <EntryTypeSelector
              value={entryTypeId}
              onChange={(id: number | null, type: EntryTypeDto | null) => {
                setEntryTypeId(id);
              }}
              required
            />
          </Box>

          <Divider />

          <Box>
            <Typography variant="subtitle2" gutterBottom>
              {isRTL ? '2️⃣ السنة المالية' : '2️⃣ Fiscal Year'}
            </Typography>
            <FiscalYearSelector
              value={fiscalYearId}
              onChange={(id: number | null) => {
                setFiscalYearId(id);
              }}
              required
            />
          </Box>

          <Divider />

          <Box>
            <Typography variant="subtitle2" gutterBottom>
              {isRTL ? '3️⃣ الحساب' : '3️⃣ Account'}
            </Typography>
            <AccountSelector
              value={accountId}
              onChange={(id: number | null) => {
                setAccountId(id);
              }}
              required
            />
          </Box>

          <Divider />

          <Box>
            <Typography variant="subtitle2" gutterBottom>
              {isRTL ? '4️⃣ مركز التكلفة' : '4️⃣ Cost Center'}
            </Typography>
            <CostCenterSelector
              value={costCenterId}
              onChange={(id: number | null) => {
                setCostCenterId(id);
              }}
            />
          </Box>
        </Box>

        <Box sx={{ mt: 3, p: 2, bgcolor: 'success.light', borderRadius: 1 }}>
          <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
            {isRTL ? '✅ القيم المختارة:' : '✅ Selected Values:'}
          </Typography>
          <Typography variant="body2">
            Entry Type ID: {entryTypeId || 'None'}
          </Typography>
          <Typography variant="body2">
            Fiscal Year ID: {fiscalYearId || 'None'}
          </Typography>
          <Typography variant="body2">
            Account ID: {accountId || 'None'}
          </Typography>
          <Typography variant="body2">
            Cost Center ID: {costCenterId || 'None'}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default SelectorsTestPage;